// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Close: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path
                fill="currentColor"
                d="M36,16 C38.8581251,16 41.4991411,14.4752083 42.9282039,12 C44.3572658,9.52479172 44.3572658,6.47520876 42.9282039,4 C41.4991411,1.52479172 38.8581251,0 36,0 C33.1418756,0 30.5008591,1.52479172 29.0717968,4 C27.6427344,6.47520876 27.6427344,9.52479172 29.0717968,12 C30.5008591,14.4752083 33.1418756,16 36,16 Z M39.0593752,6 L38.5281252,6.53125 L37.0593752,8 L38.5281252,9.46875 L39.0593752,10 L38.0000004,11.0593748 L37.4687504,10.5281248 L36.0000004,9.05937481 L34.5312504,10.5281248 L34.0000004,11.0593748 L32.9406255,10 L33.4718755,9.46875 L34.9406255,8 L33.4718755,6.53125 L32.9406255,6 L34.0000004,4.94062519 L34.5312504,5.47187519 L36.0000004,6.94062519 L37.4687504,5.47187519 L38.0000004,4.94062519 L39.0593752,6 Z"
                transform="translate(-28)"
            />
        </svg>
    );
};

export default React.memo(Close);
